(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-gallery"] && !window.DesignMode) return;
  try {
    
(function(){
  if (!window.gsap || !window.ScrollTrigger) return;

  const resetScrollTriggers = () => {
    ScrollTrigger.getAll().forEach(st => st.kill());
    gsap.killTweensOf("*");
  };

  const getRowElements = (item) => {
    const image = item.querySelector(".animated-gallery-block__image");
    const desc = item.querySelector(".animated-gallery-block__desc");
    const info = item.querySelector(".animated-gallery-block__info");
    const imageWrap = item.querySelector(".animated-gallery-block__imagewrap");

    return { image, desc, imageWrap, info };
  }

  const desktopAnimation = (item, controls, i) => {
      const { image, desc } = getRowElements(item);
      // Pair A[i] with B[i]; if B is shorter, reuse the last B
      const control = controls[i] || controls[controls.length - 1];

      // Fallback if there are zero controls
      const dynamicEnd = () => {
        if (!control) return "+=" + item.offsetHeight; // reasonable default
        return "+=" + control.offsetHeight;
      };

      const tl = gsap.timeline(
        {
          defaults: { ease: "none" },
          scrollTrigger: {
            trigger: control,
            start: "top 80%",
            end: dynamicEnd,
            scrub: 0.1,
            invalidateOnRefresh: true,
            fastScrollEnd: true,
            //markers: true,
          }
        }
      );

      if(image) {
        tl.to(image, {
            height: control.offsetHeight,
          }, 0);
      }

      tl.to(desc, {
          opacity: 1,
          height: 'auto',
          duration: .2
      }, 0);
  }

  const mobileAnimation = (item) => {
    const { imageWrap, info, desc } = getRowElements(item);
          const itemHeight = item.clientHeight;
          let itemImgWidth, itemImgHeight;

          if(imageWrap) {
            itemImgWidth = imageWrap.clientWidth;
            itemImgHeight = imageWrap.clientHeight;

            imageWrap.setAttribute('data-animation-start-width', itemImgWidth);
            imageWrap.setAttribute('data-animation-start-height', itemImgHeight);
          }

          item.addEventListener("click", function(){

            if(item.classList.contains("is-transitioning")) {
              return;
            }

            if(item.classList.contains("is-open")) {
              const tl = gsap.timeline({
                onStart: () => {
                  item.classList.add('is-transitioning');
                },
                onComplete: () => {
                  item.classList.remove('is-transitioning');
                  item.classList.remove("is-open");

                  if(imageWrap) {
                    gsap.to(imageWrap, {
                      height: 'auto',
                      duration: .15
                    });
                  }
                }
              })
              .to(desc, {
                  opacity: 0,
                  height: 0,
              })
              if(imageWrap) {
                tl.to(imageWrap, {
                  width: parseInt(imageWrap.getAttribute('data-animation-start-width')),
                  height: 0
                }, 0.4);
              }

            } else {
              const tl = gsap.timeline({
                onStart: () => {
                  item.classList.add('is-transitioning');
                  item.classList.add("is-open");
                },
                onComplete: () => {
                  item.classList.remove('is-transitioning');
                }
              });

              if(imageWrap) {
                tl.fromTo(imageWrap, {
                  width: itemImgWidth,
              }, {
                  width: '100%',
                }, 0)
              }

              tl.to(desc, {
                  opacity: 1,
                  height: 'auto',
              }, 0);
            }
    });
  }

  gsap.registerPlugin(ScrollTrigger);

  function setup() {
    resetScrollTriggers();

    const items = gsap.utils.toArray(".animated-gallery-block");
    const controls = gsap.utils.toArray(".animated-gallery-block__sentinel-block");

    if (!items.length) return;

    items.forEach((item, i) => {
      item.classList.remove("is-open");
      item.classList.remove('is-transitioning');

      if(window.innerWidth >= 750) {
          desktopAnimation(item, controls, i);
        } else {
          mobileAnimation(item);
        }
    });
  }
  // Initial setup
  setup();

  // Recompute after images/fonts load (ensures honest heights)
  window.addEventListener("load", () => ScrollTrigger.refresh());
  let window_width = window.innerWidth;
  window.addEventListener("resize", () => {
    if(window_width === window.innerWidth) return; // skip if only height changed - avoids excessive recalcs and bugs on safari iOS

    setup();
    ScrollTrigger.refresh()
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logos-showcase"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiperElement = document.querySelector('.logos-showcase__swiper');
    if (swiperElement && typeof Swiper !== 'undefined') {
      new Swiper(swiperElement, {
        initialSlide: 1,
        slidesPerView: 2,
        centeredSlides: true,
        spaceBetween: 30,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 40,
            centeredSlides: false
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !window.DesignMode) return;
  try {
    
  function initSlider() {
    const swiperElements = document.querySelectorAll('.product-carousel__swiper');

    if (swiperElements.length && typeof Swiper !== 'undefined') {
      swiperElements.forEach(function(swiperElement) {
        if(swiperElement.getAttribute('data-items') === '1') return;

        var hasEnoughItems = swiperElement.getAttribute('data-items') > 4 ? true : false;

        new Swiper(swiperElement, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 24,
          centeredSlides: hasEnoughItems,
          loop: hasEnoughItems,
          breakpoints: {
            650: {
              initialSlide: 2,
              slidesPerView: 2
            },
            1024: {
              initialSlide: 3,
              slidesPerView: 3
            },
            1600: {
              initialSlide: 4,
              slidesPerView: 4
            },
            1920: {
              initialSlide: 5,
              slidesPerView: 5
            }
          },
          pagination: {
            el: swiperElement.querySelector('.swiper-pagination'),
            clickable: true
          },
          on: {
            init: function() {
              checkPagination(this);
            },
            resize: function() {
              checkPagination(this);
            },
            update: function() {
              checkPagination(this);
            },
            slideChange: function() {
              checkPagination(this);
            },
            breakpoint: function() {
              checkPagination(this);
            }
          }
        });
      });
    }
  }

  function checkPagination(swiperInstance) {
    const container = swiperInstance.el;
    const isBeginning = swiperInstance.isBeginning;
    const isEnd = swiperInstance.isEnd;
    const allowSlideNext = swiperInstance.allowSlideNext;
    const allowSlidePrev = swiperInstance.allowSlidePrev;

    // Se siamo all'inizio AND alla fine, e non possiamo scorrere, non serve paginazione
    const needsPagination = !(isBeginning && isEnd && !allowSlideNext && !allowSlidePrev);

    // Alternativa: controlla se ci sono bullets nella paginazione
    const paginationBullets = swiperInstance.pagination?.bullets?.length || 0;
    const hasPagination = paginationBullets > 1;

    if (!needsPagination || !hasPagination) {
      container.classList.add('no-pagination');
      container.setAttribute('data-pagination-hidden', 'true');
    } else {
      container.classList.remove('no-pagination');
      container.setAttribute('data-pagination-hidden', 'false');
    }
  }

  document.addEventListener('shopify:section:load', initSlider);
  document.addEventListener('DOMContentLoaded', initSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  function initRecommendationsSlider() {
    const swiperElements = document.querySelectorAll('.product-carousel__swiper');

    if (swiperElements.length && typeof Swiper !== 'undefined') {
      swiperElements.forEach(function(swiperElement) {
        var hasEnoughItems = swiperElement.getAttribute('data-items') > 4 ? true : false;

        new Swiper(swiperElement, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 24,
          centeredSlides: hasEnoughItems,
          loop: hasEnoughItems,
          breakpoints: {
            650: {
              initialSlide: 2,
              slidesPerView: 2
            },
            1024: {
              initialSlide: 3,
              slidesPerView: 3
            },
            1600: {
              initialSlide: 4,
              slidesPerView: 4
            },
            1920: {
              initialSlide: 5,
              slidesPerView: 5
            }
          },
          pagination: {
            el: swiperElement.querySelector('.swiper-pagination'),
            clickable: true
          },
          on: {
            init: function() {
              checkRecommendationsPagination(this);
            },
            resize: function() {
              checkRecommendationsPagination(this);
            },
            update: function() {
              checkRecommendationsPagination(this);
            },
            slideChange: function() {
              checkRecommendationsPagination(this);
            },
            breakpoint: function() {
              checkRecommendationsPagination(this);
            }
          }
        });
      });
    }
  }

  function checkRecommendationsPagination(swiperInstance) {
    const container = swiperInstance.el;
    const isBeginning = swiperInstance.isBeginning;
    const isEnd = swiperInstance.isEnd;
    const allowSlideNext = swiperInstance.allowSlideNext;
    const allowSlidePrev = swiperInstance.allowSlidePrev;

    // Se siamo all'inizio AND alla fine, e non possiamo scorrere, non serve paginazione
    const needsPagination = !(isBeginning && isEnd && !allowSlideNext && !allowSlidePrev);

    // Alternativa: controlla se ci sono bullets nella paginazione
    const paginationBullets = swiperInstance.pagination?.bullets?.length || 0;
    const hasPagination = paginationBullets > 1;

    if (!needsPagination || !hasPagination) {
      container.classList.add('no-pagination');
      container.setAttribute('data-pagination-hidden', 'true');
    } else {
      container.classList.remove('no-pagination');
      container.setAttribute('data-pagination-hidden', 'false');
    }
  }

  document.addEventListener('shopify:section:load', initRecommendationsSlider);
  document.addEventListener('galup:recommendations:loaded', initRecommendationsSlider);

  } catch(e) { console.error(e); }
})();
})();
